// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import queryString from 'query-string'

type QueryParams = {
  [key: string]: ?string,
}

export const buildPageSearch = (
  page: number,
  queryParams: QueryParams = {},
) => {
  const nextQueryParams: { [key: string]: string } = {}

  Object.keys(queryParams).forEach(key => {
    const value = queryParams[key]
    if (value !== null && value !== undefined && value !== '') {
      nextQueryParams[key] = value
    }
  })

  return `?${queryString.stringify({ ...nextQueryParams, page })}`
}

export default function Pager({
  variables,
  pathName,
  pageInfo,
  windowSize,
  queryParams,
}: {
  variables: {
    page: number,
    perPage: number,
  },
  pathName: string,
  pageInfo: {
    currentPage: number,
    previousPage: number,
    nextPage: number,
    totalPages: number,
    totalCount: number,
  },
  windowSize: number,
  queryParams?: QueryParams,
}) {
  const shouldShowPageSize = windowSize * 2 + 1
  let startPage = pageInfo.currentPage - windowSize
  let endPage = pageInfo.currentPage + windowSize

  startPage = startPage < 1 ? 1 : startPage
  endPage = endPage > pageInfo.totalPages ? pageInfo.totalPages : endPage
  if (endPage - startPage + 1 < shouldShowPageSize) {
    if (endPage < pageInfo.totalPages) {
      endPage = startPage + windowSize * 2
    } else {
      endPage = pageInfo.totalPages
      startPage = endPage - windowSize * 2
    }
  }

  let beginningNum
  let endNum
  if (variables.page > 1) {
    beginningNum = (variables.page - 1) * variables.perPage + 1
    endNum = (variables.page - 1) * variables.perPage + variables.perPage
  } else {
    beginningNum = variables.page
    endNum = variables.page * variables.perPage
  }

  return (
    <div className="ta-c pt15">
      <p>
        <strong>
          {pageInfo.totalCount}
          {i18n.t('page.shared.l_00012')}
        </strong>
        {beginningNum}～{endNum}
        {i18n.t('page.shared.l_00011')}
      </p>
      <div className="page-nav mb70">
        {pageInfo.hasPreviousPage ? (
          <Link
            className="stay-page-nav__numbers is-prev"
            to={buildPageSearch(pageInfo.previousPage, queryParams)}
          >
            <i className="fa fa-angle-left" />
          </Link>
        ) : null}
        {Array.from(Array(pageInfo.totalPages), (_, i) => {
          const pageNumber = i + 1
          if (startPage > pageNumber || endPage < pageNumber) {
            return null
          } else if (pageInfo.currentPage === pageNumber) {
            return (
              <span key={i} className="page-nav__numbers is-current">
                {pageNumber}
              </span>
            )
          }
          return (
            <Link
              className="page-nav__numbers"
              key={i}
              to={buildPageSearch(pageNumber, queryParams)}
            >
              {pageNumber}
            </Link>
          )
        })}
        {pageInfo.hasNextPage ? (
          <Link
            className="page-nav__numbers is-next"
            to={buildPageSearch(pageInfo.nextPage, queryParams)}
          >
            <i className="fa fa-angle-right" />
          </Link>
        ) : null}
      </div>
    </div>
  )
}
